import { useEffect, useState } from 'react';

import useInView from '../../hooks/useInView';
import { prefersReducedMotion } from '../../hooks/usePrefersReducedMotion';

/** Animates a number from 0 to `end` the first time it scrolls into view. */
export default function CountUp({ end, decimals = 0, duration = 1800, suffix = '', prefix = '' }) {
  const [ref, inView] = useInView({ threshold: 0.1, rootMargin: '0px' });
  const [value, setValue] = useState(0);

  useEffect(() => {
    if (!inView) return undefined;
    if (prefersReducedMotion()) {
      setValue(end);
      return undefined;
    }
    let frame;
    const start = performance.now();
    const tick = (now) => {
      const t = Math.min(1, (now - start) / duration);
      const eased = 1 - Math.pow(1 - t, 4);
      setValue(end * eased);
      if (t < 1) frame = requestAnimationFrame(tick);
    };
    frame = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(frame);
  }, [inView, end, duration]);

  return (
    <span ref={ref}>
      {prefix}
      {value.toFixed(decimals)}
      {suffix}
    </span>
  );
}
